import { useApiClient } from '../../../../helpers/api/apiCoreNewClient';

export interface AddContainerSortDto {
    numberOfContainer: number,
    licensePlate: string
}

export const SortApiService = () => {
    const client = useApiClient();

    return {
        addSortConfig: (name: string, companySortCodesIds: number[]) => {
            return client.post('api/SortCodeConfig', {name: name, companySortCodesIds: companySortCodesIds}, {showLoading: true});
        },

        updateSortConfig: (id: number, name: string, companySortCodesIds: number[]) => {
            return client.put(`api/SortCodeConfig/${id}`, {name: name, companySortCodesIds: companySortCodesIds}, {showLoading: true});
        },
        deleteSortConfig: (id: number) => {
            return client.delete(`api/SortCodeConfig/${id}`, {showLoading: true});
        },
        addContainer: (data: AddContainerSortDto) => {
            return client.post(`api/Containers?isSortContainer=true`, data);
        },
    }
}